const getRuntimeConfig = async () => {
    const fileName = "/config." + process.env.NODE_ENV + ".json";
    const myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    const myInit = {
        method: 'GET',
        headers: myHeaders,
    };
    const config = await fetch(fileName, myInit);
    return await config.json();
};

export default {
    namespaced: true,
    state: {
        data: null
    },
    mutations: {
        update_data(state, data) {
            state.data = data;
        }
    },
    actions: {
        initialize({ commit }) {
            return new Promise((resolve, reject) => {
                getRuntimeConfig().then((response) => {
                    commit('update_data', response);
                    resolve(response);
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    },
    getters: {
        data: (state) => {
            return state.data;
        }
    }
};